// eslint-disable-next-line
export const areAllQueryDataFetched = gqlResponses => {
  const responseOnLoading = gqlResponses.find((gqlResponse) => gqlResponse.loading);

  return responseOnLoading === undefined;
};
